<template>
  <div v-if="protectedRoute && sessionBlocked" class="session-cover" role="dialog" aria-modal="true" aria-labelledby="session-title">
    <section>
      <template v-if="sessionPrompt">
        <h1 id="session-title">Are you still there?</h1>
        <p>Your session has reached one hour.</p>
        <p>Automatic sign-out in {{ countdown }}.</p>
        <button @click="renewAdminSession">Yes, another hour</button>
        <button @click="endAdminSession">No, sign out</button>
      </template>
      <template v-else>
        <h1 id="session-title"><span :class="{ 'session-checking-text': !sessionError }">{{ sessionError || 'Checking your session…' }}</span></h1>
        <button v-if="sessionError" @click="endAdminSession">Retry sign out</button>
      </template>
    </section>
  </div>
  <router-view v-else/>
</template>

<script setup>
import { computed, onUnmounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { sessionMfaRequired, sessionBlocked, sessionPrompt, sessionSeconds, sessionError, renewAdminSession, endAdminSession, startAdminSessionController } from '@/security/adminSession';

const route = useRoute();
const router = useRouter();
watch([sessionMfaRequired, () => route.path], ([required, path]) => {
  if (required && path !== '/admin-security') void router.replace('/admin-security');
});
const protectedRoute = computed(() => route.matched.some(record => record.meta.adminOnly) && !(route.path === '/admin-security' && sessionMfaRequired.value));
const countdown = computed(() => `${Math.floor(sessionSeconds.value / 60)}:${String(sessionSeconds.value % 60).padStart(2, '0')}`);
onUnmounted(startAdminSessionController());
</script>

<style>
.session-cover { position: fixed; inset: 0; z-index: 10000; display: grid; place-items: center; background: #082f4f; color: white; text-align: center; padding: 24px; }
.session-cover section { max-width: 480px; }
.session-checking-text { font-size: 50%; }
.session-cover button { margin: 8px; padding: 12px 20px; border: 0; border-radius: 24px; background: #f6bc05; color: #082f4f; }

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
